// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/fuse-holder/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteFuseHolderEN: PageEntry = {
  id: "example.produkte-sicherungshalter",
  locale: "en",
  slug: "produkte/fuse-holder",
  seo: {
    title: "Fuse holder | Dietz GmbH",
    description: "Fuse holder",
  },
  type: "post",
  h1: "Fuse holder",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_elektrotechnik.jpg", alt: "Fuse holder", width: 700, height: 560 }
  ],
};
